import { render, staticRenderFns } from "./MarkdownEditorView.vue?vue&type=template&id=656e4f05&scoped=true&"
import script from "./MarkdownEditorView.vue?vue&type=script&lang=js&"
export * from "./MarkdownEditorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e4f05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
